<template>
  <div>
    <div v-html="blockContent.replace(
      /https:\/\/parkos/g,
      `https://${$paths.urlEnvPrefix}parkos`
    )
      " />
    <ul v-if="slug === 'footer_about'">
      <li v-if="aboutPageLink" id="dynamic-placeholder"
        :class="['text-white text-[14px] xs:text-base']"
        >
        <a :href="aboutPageLink">
          <div class="shrink-0 flex-1 w-full whitespace-nowrap text-ellipsis overflow-hidden mr-2">
            {{ aboutPageTitle }}
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    slug: undefined,
  },

  computed: {
    blockContent() {
      if (!this.template?.page_content && this.slug === "footer_airports") {
        return `
      <ul>\r\n
      <li><strong>${this.$i18n("general.airports")}</strong></li>\r\n
      ${this.airports
            .map(
              (airport) =>
                `<li><a class="text-white hover:text-white" href="/${airport.slug}/">${airport.name}</a></li>\r\n`
            )
            .slice(0, 5)
            .join("")}
      </ul>
    `;
      }

      return this.template?.page_content ?? "";
    },

    template() {
      return this.$store.state.pageTemplate[this.slug];
    },
    airports() {
      return this.$store.state.airports;
    },
    language() {
      return this.$store.state.language;
    },
    aboutPageLink() {
      if (this.aboutPageContent && this.language && this.language.lang) {
        const currentContent = this.aboutPageContent;
        return `/${currentContent.slug}.html`;
      }
      return null;
    },
    aboutPageTitle() {
      if (this.aboutPageContent && this.language && this.language.lang) {
        const currentContent = this.aboutPageContent;
        return currentContent.title;
      }
      return null;
    },
    aboutPageContent() {
      return this.$store.state.pageContent.aboutPageContent;
    },
  },
};
</script>

<style scoped>
.text-white a,
.text-white a:hover {
  color: inherit;
}

.strong {
  font-weight: bolder;
}
</style>
